import { create } from "zustand";

type TClientsFilterStore = {
  filters: Record<string, string[]>;
  addFilter: (filterKey: string, value: string) => void;
  removeFilter: (filterKey: string, value: string) => void;
  resetFilters: (filterKey: string) => void;
  resetAllFilters: () => void;
  getValues: (filterKey: string) => string[];
};

export const useClientsFilterBaseStore = create<TClientsFilterStore>((set, get) => ({
  filters: {},
  addFilter: (filterKey, value) =>
    set((state) => {
      const existingFilters = state.filters[filterKey] || [];
      if (existingFilters.includes(value)) return state;

      return {
        filters: {
          ...state.filters,
          [filterKey]: [...existingFilters, value],
        },
      };
    }),
  removeFilter: (filterKey, value) =>
    set((state) => ({
      filters: {
        ...state.filters,
        [filterKey]: (state.filters[filterKey] || []).filter((item) => item !== value),
      },
    })),
  resetFilters: (filterKey) =>
    set((state) => ({
      filters: {
        ...state.filters,
        [filterKey]: [],
      },
    })),
  resetAllFilters: () => set({ filters: {} }),
  getValues: (filterKey) => get().filters[filterKey] || [],
}));

export const useClientsFilterStore = (filterKey: string) => {
  const addFilter = useClientsFilterBaseStore((state) => state.addFilter);
  const removeFilter = useClientsFilterBaseStore((state) => state.removeFilter);
  const resetFilters = useClientsFilterBaseStore((state) => state.resetFilters);
  const filters = useClientsFilterBaseStore((state) => state.filters);

  const values = filterKey === "all" ? Object.values(filters).flat() : filters[filterKey] || [];

  return {
    values,
    filters,
    addFilter: (value: string) => addFilter(filterKey, value),
    removeFilter: (value: string) => removeFilter(filterKey, value),
    resetFilters: () => resetFilters(filterKey),
  };
};
